<template>
  <Page title="Férias">
    <v-container>
      <v-card>
        <v-card-title>
          Solicitações
        </v-card-title>
        <v-toolbar elevation="0">
          <v-tabs>
            <v-tab :to="{ name: 'vacation_admin_active' }" exact>
              Ativas
            </v-tab>
            <v-tab :to="{ name: 'vacation_admin_pending' }" exact>
              Pendentes
            </v-tab>
            <v-tab :to="{ name: 'vacation_admin_all' }" exact>
              Todas
            </v-tab>
          </v-tabs>
        </v-toolbar>
        <v-divider></v-divider>

        <router-view></router-view>
      </v-card>
    </v-container>
  </Page>
</template>

<script>
import Page from "@/components/layout/Page";

export default {
  components: { Page }
};
</script>
